module.exports = __webpack_public_path__ + "static/media/moderating-icon.103a019d.svg";